import { siteInfo } from '@/mocks/novels';

export default function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            关于都市美艳后宫
          </h1>
          <p className="text-lg text-foreground-500 font-heading">{siteInfo.tagline}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 mb-12">
          <div className="rounded-lg overflow-hidden h-64 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20modern%20reading%20space%20with%20warm%20ambient%20lighting%20bookshelves%20Chinese%20books%20cozy%20armchair%20golden%20sunlight%20large%20window%20sophisticated%20interior%20peaceful%20atmosphere&width=700&height=500&seq=about-brand-01&orientation=landscape"
              alt="都市美艳后宫阅读空间"
              title="都市美艳后宫 - 精品阅读空间"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
              品牌故事
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              都市美艳后宫成立于{siteInfo.foundingYear}年，是国内领先的都市爽文阅读平台。我们专注于都市后宫、逆袭、热血等题材的精品小说内容，致力于为广大读者提供最优质的阅读体验。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              从最初的几个志同道合的书友，到如今拥有{siteInfo.totalReaders.toLocaleString()}位读者的大型阅读社区，我们始终坚持&ldquo;精品内容、极致体验&rdquo;的核心理念，精心挑选每一部作品，确保每位读者都能在这里找到属于自己的阅读乐趣。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              我们相信，好的故事能够跨越时间和空间，触动每一个读者的心灵。都市美艳后宫，不仅是阅读平台，更是无数读者梦想与情感的精神家园。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="text-center p-6 rounded-lg bg-background-100">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-3">
              <i className="ri-book-open-line text-xl text-primary-500"></i>
            </div>
            <p className="font-heading text-2xl font-bold text-foreground-900">{siteInfo.totalNovels.toLocaleString()}+</p>
            <p className="text-xs text-foreground-500 mt-1">精品小说</p>
          </div>
          <div className="text-center p-6 rounded-lg bg-background-100">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-3">
              <i className="ri-user-heart-line text-xl text-accent-500"></i>
            </div>
            <p className="font-heading text-2xl font-bold text-foreground-900">{siteInfo.totalReaders.toLocaleString()}+</p>
            <p className="text-xs text-foreground-500 mt-1">忠实读者</p>
          </div>
          <div className="text-center p-6 rounded-lg bg-background-100">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-3">
              <i className="ri-file-text-line text-xl text-secondary-500"></i>
            </div>
            <p className="font-heading text-2xl font-bold text-foreground-900">{(siteInfo.totalWords / 100000000).toFixed(1)}亿+</p>
            <p className="text-xs text-foreground-500 mt-1">字内容</p>
          </div>
          <div className="text-center p-6 rounded-lg bg-background-100">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-3">
              <i className="ri-calendar-check-line text-xl text-primary-500"></i>
            </div>
            <p className="font-heading text-2xl font-bold text-foreground-900">{new Date().getFullYear() - siteInfo.foundingYear}+年</p>
            <p className="text-xs text-foreground-500 mt-1">行业深耕</p>
          </div>
        </div>
      </div>
    </section>
  );
}